import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PointExchangeAPI from "../../../../../apiConfig/PointExchangeAPI";
import { Status } from "../../../../../redux/constant";

const initialState = {
  convertPartnerRedirectAuth: {},
  status: Status.INITIAL,
  errorMessage: null,
};

export const fetchAsyncConvertPartnerRedirectAuth = createAsyncThunk(
  "convertPartnerRedirectAuth/fetchAsyncConvertPartnerRedirectAuth",
  async ({ partnerId }, { rejectWithValue }) => {
    try {
      const response = await PointExchangeAPI.get(
        `/partners/${partnerId}/authorize`,
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue({
          status: err.response.status,
          data: err.response.data,
        });
      }
      return rejectWithValue({
        status: "",
        data: err.message,
      });
    }
  },
);

const ConvertPartnerRedirectAuthSlice = createSlice({
  name: "convertPartnerRedirectAuth",
  initialState,
  reducers: {
    resetConvertPartnerRedirectAuth: state => {
      state.convertPartnerRedirectAuth = {};
      state.status = Status.INITIAL;
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAsyncConvertPartnerRedirectAuth.pending, state => {
        state.errorMessage = null;
        state.status = Status.LOADING;
      })
      .addCase(
        fetchAsyncConvertPartnerRedirectAuth.fulfilled,
        (state, { payload }) => {
          state.convertPartnerRedirectAuth = payload;
          state.status = Status.LOADED;
        },
      )
      .addCase(
        fetchAsyncConvertPartnerRedirectAuth.rejected,
        (state, { payload }) => {
          if (payload === undefined) {
            state.status = Status.ERROR;
            return;
          }
          state.errorMessage = payload.data;
          state.status = Status.ERROR;
        },
      );
  },
});

export const { resetConvertPartnerRedirectAuth } =
  ConvertPartnerRedirectAuthSlice.actions;

export default ConvertPartnerRedirectAuthSlice.reducer;
